import { render, staticRenderFns } from "./JobsPending.vue?vue&type=template&id=32b845fb&scoped=true"
import script from "./JobsPending.vue?vue&type=script&lang=js"
export * from "./JobsPending.vue?vue&type=script&lang=js"
import style0 from "./JobsPending.vue?vue&type=style&index=0&id=32b845fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b845fb",
  null
  
)

export default component.exports